import {Button, IconButton, TextField} from '@wandb/components';
import React, {useState} from 'react';

import {WorkspaceDrawerScroller} from '../WorkspaceDrawerScroller';
import {FOOTER_ACTIONS_HEIGHT} from './constants';
import {usePanelsQuickAddContext} from './PanelsQuickAddContext';
import {validateMultiMetricQuickAddRegex} from './utils/regex';

type MultiMetricPanelAddProps = {
  onBack: () => void;
  initialRegex?: string;
};

export const MultiMetricPanelAdd = ({
  onBack,
  initialRegex,
}: MultiMetricPanelAddProps) => {
  const {closeQuickAdd} = usePanelsQuickAddContext();
  const [regex, setRegex] = useState(initialRegex ?? '');
  const {errorMessage: regexValidationError} =
    validateMultiMetricQuickAddRegex(regex);

  return (
    <div>
      <div className="border-b border-solid border-moon-250 px-24 ">
        <div className="flex items-center justify-between py-16">
          <IconButton
            variant="ghost"
            icon="back"
            aria-label="Back"
            onPress={onBack}
          />
          <IconButton
            variant="ghost"
            icon="close"
            aria-label="Close"
            onPress={closeQuickAdd}
          />
        </div>
        <h2 className="text-xl font-semibold leading-[32px]">
          Create multi-metric panels
        </h2>
        <p className="pb-16 text-moon-500">
          Use regex to group multiple metrics within the same panels.
        </p>
      </div>
      <WorkspaceDrawerScroller footerHeight={FOOTER_ACTIONS_HEIGHT}>
        <div className="p-24">
          <TextField
            label="Regex"
            value={regex}
            onChange={setRegex}
            validate={() => regexValidationError ?? true}
            fullWidth
          />
        </div>
      </WorkspaceDrawerScroller>
      <div className="border-t border-solid border-moon-250 p-16">
        <Button fullWidth>Create panels</Button>
      </div>
    </div>
  );
};
